import { useEffect, useState, useRef } from "react"
import {
	Logo,
	Background,
	CamereView,
	Instructions,
	Loading,
} from "./components/UI"
import { changeView, Canvas } from "./3D/setup"
import { Menu } from "./components/Menu"
import { SpatialUI, GeneralSettings } from "./components/SpatialMenu"
import { ToggleOutfit } from "./components/ToggleOutfit"
import "./styles.css"
import "./App.css"
function App() {
	const [sceneLoaded, setSceneLoaded] = useState(false)
	const [showBackground, setShowBackground] = useState(true)
	const [amountCompleted, setAmountCompleted] = useState(0)
	const loadedOnce = useRef(false)
	const renderedOnce = useRef(false)
	function loaded() {
		if (!sceneLoaded && !loadedOnce.current) {
			setSceneLoaded(true)
			setTimeout(() => {
				setShowBackground(false)
			}, 500)
			loadedOnce.current = true
			//renderedOnce.current = true
		}
	}
	useEffect(() => {
		if (sceneLoaded && loadedOnce.current) {
			loadedOnce.current = false // Mark as rendered
			console.log("renderOnce")
			renderedOnce.current = true
			// Execute any additional logic needed once
		}
	}, [sceneLoaded]) // Depend on sceneLoaded to trigger this effect

	function updateProgress(
		circleId: string,
		radius: number,
		percentage: number
	): void {
		const circle = document.getElementById(
			circleId
		) as unknown as SVGCircleElement
		if (!circle) {
			console.error(`Circle with id '${circleId}' not found.`)
			return
		}

		const circumference = 2 * Math.PI * radius
		const offset = circumference - (percentage / 100) * circumference

		circle.style.strokeDasharray = `${circumference}`
		circle.style.strokeDashoffset = `${offset}`
	}

	function progress(value: number) {
		setAmountCompleted(value)
		updateProgress("progressCircle", 156, value)
	}

	return (
		<div className="App">
			{sceneLoaded && loadedOnce.current && renderedOnce.current && (
				<>
					<CamereView selectionChange={changeView} />
					<ToggleOutfit />
					<Menu />
					<SpatialUI></SpatialUI>
					<GeneralSettings></GeneralSettings>
					<Instructions />
					<Logo />
				</>
			)}
			<Canvas onLoaded={loaded} onProgress={progress} />
			{showBackground && <Background onLoaded={sceneLoaded} />}
			{!sceneLoaded && <Loading />}
		</div>
	)
}

export default App
